<template>
  <div>
    <div class="text-xs-center mt-4 mb-4" v-if="loading">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else-if="user">
      <template v-if="selectedBot.theme == 'universalutilities'">
        <uu-customer-detail v-model="user">
          <div slot="header">&nbsp;</div>
        </uu-customer-detail>
      </template>
      <template v-else-if="['hafele', 'scgallrent'].includes(selectedBot.theme)">
        <customer-detail v-model="user.id" :getuseronly="true">
          <div slot="header">&nbsp;</div>
        </customer-detail>
      </template>
      <template v-else-if="['ticket'].includes(selectedBot.theme)">
        <ticket-customer-detail v-model="user.id">
          <div slot="header">&nbsp;</div>
        </ticket-customer-detail>
      </template>
      <template v-else-if="$store.state.toapainterpage.includes(selectedBot.pageid)">
        <toa-painter-info :readonly="true" v-model="user" :user="user">
          <div slot="header">&nbsp;</div>
        </toa-painter-info>
      </template>
      <template v-else>
        <customer-detail v-model="user.id" :getuseronly="true">
          <div slot="header">&nbsp;</div>
        </customer-detail>
      </template>
    </div>
    <div v-else>
      <div class="text-xs-center mt-4 mb-4">
        <v-icon x-large>error_outline</v-icon>
        <p>No detail</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import CustomerDetail from '@/components/view/dashboard/CustomerDetail.vue'
import UuCustomerDetail from '@/components/view/dashboard/UuCustomerDetail.vue'
import HafeleCustomerDetail from '@/components/view/dashboard/HafeleCustomerDetail.vue'
import TicketCustomerDetail from '@/components/view/dashboard/TicketCustomerDetail.vue'
import ToaPainterInfo from '@/components/view/dashboard/ToaPainterInfo.vue'
export default {
  props: ['value'],
  components: {
    CustomerDetail,
    UuCustomerDetail,
    HafeleCustomerDetail,
    TicketCustomerDetail,
    ToaPainterInfo,
  },
  data: function () {
    return {
      loading: true,
      user: undefined,
      chatboxHeight: 0,
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
    }),
  },
  mounted: function () {
    var vm = this

    vm.loading = true

    vm.getUser(vm.value.userid).then(
      function (user) {
        if (user) {
          vm.user = user
        }
        vm.loading = false
      },
      function (error) {
        vm.loading = false
      }
    )
  },
  methods: {
    onResizeChatbox: function () {
      var vm = this
      setTimeout(() => {
        vm.chatboxHeight =
          window.innerHeight - document.getElementById('main_toolbar').clientHeight - 5
        if (document.getElementById('chatinput')) {
          vm.chatinputHeight = document.getElementById('chatinput').clientHeight
        }
      }, 500)
    },
    getUser: function (userid) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          userid: userid,
          pageid: vm.selectedBot.pageid,
        }
        api.getUserOnly(data, function (error, response) {
          if (error) {
            reject(error)
          }

          if (response.data) {
            resolve(response.data[0])
          } else {
            resolve(undefined)
          }
        })
      })
    },
  },
  watch: {
    value: function (newVal) {
      var vm = this

      if (newVal == null) {
        vm.user = undefined
      } else {
        vm.loading = true

        vm.getUserOnly(newVal.userid).then(
          function (user) {
            if (user) {
              vm.user = user
            }
            vm.loading = false
          },
          function (error) {
            vm.loading = false
          }
        )
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-customers.vue